import React from "react";
import {
  Container,
  Card,
  Button,
  Spinner,
  Alert,
  Badge,
  Row,
  Col,
} from "react-bootstrap";
import {
  FaTrash,
  FaEdit,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaUserShield,
} from "react-icons/fa";
import { LinkContainer } from "react-router-bootstrap";
import { useDeleteUserMutation, useGetUsersQuery } from "../slices/userApiSlice";
import { toast } from "react-toastify";

const UserListScreen = () => {
  const { data: users, refetch, isLoading, error } = useGetUsersQuery();
  const [deleteUser] = useDeleteUserMutation();

  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteUser(id);
        refetch();
        toast.success("User deleted successfully");
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <Container fluid className="py-3">
      <h2 className="text-primary mb-4">👥 User Management</h2>

      {isLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status" />
        </div>
      ) : error ? (
        <Alert variant="danger">{error?.data?.message || error.error}</Alert>
      ) : users && users.length > 0 ? (
        <Row className="g-3">
          {users.map((user) => {
            const addr = user.addresses?.[0];
            return (
              <Col key={user._id} xs={12} sm={6} md={4}>
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title className="fw-bold mb-2">
                      <FaUser className="me-2" />
                      {user.name}
                    </Card.Title>

                    <Card.Text className="mb-1">
                      <FaEnvelope className="me-1" />
                      {user.email || <Badge bg="secondary">N/A</Badge>}
                    </Card.Text>

                    <Card.Text className="mb-1">
                      <FaUserShield className="me-1" />
                      <Badge
                        bg={user.role === "admin" ? "danger" : "info"}
                        className="text-uppercase"
                      >
                        {user.role}
                      </Badge>
                    </Card.Text>

                    <Card.Text className="mb-1">
                      <FaPhone className="me-1" />
                      {user.phone || <Badge bg="secondary">N/A</Badge>}
                    </Card.Text>

                    <Card.Text>
                      <FaMapMarkerAlt className="me-1" />
                      {addr ? (
                        <>
                          <div>
                            <strong>{addr.address}</strong>
                          </div>
                          <div className="text-muted small">
                            {addr.area}, {addr.city} - {addr.pincode}
                          </div>
                          {addr.phoneNumber && (
                            <div className="text-muted small">📞 {addr.phoneNumber}</div>
                          )}
                        </>
                      ) : (
                        <Badge bg="secondary">N/A</Badge>
                      )}
                    </Card.Text>

                    <div className="d-flex justify-content-between flex-wrap mt-2">
                      <LinkContainer to={`/admin/user/${user._id}/edit`}>
                        <Button variant="outline-warning" size="sm">
                          <FaEdit className="me-1" /> Edit
                        </Button>
                      </LinkContainer>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => deleteHandler(user._id)}
                      >
                        <FaTrash className="me-1" /> Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <div className="text-center py-3">No users found.</div>
      )}
    </Container>
  );
};

export default UserListScreen;
